import { AxiosRequestConfig } from 'axios';

export const firebase = {
  apiKey: 'AIzaSyD2p48JEWILP-61UzBjIh-Yh6PWdrJrfwk',
  appId: '1:983263249595:web:698653dd4e439eb9',
  authDomain: 'onyx-harmony-239219.firebaseapp.com',
  databaseURL: 'https://onyx-harmony-239219.firebaseio.com',
  messagingSenderId: '983263249595',
  projectId: 'onyx-harmony-239219',
  storageBucket: 'onyx-harmony-239219.appspot.com',
};

export const apiRest = {
  baseURL: 'https://onyx-harmony-239219.firebaseapp.com/api/rest',
} as AxiosRequestConfig;

export const apiDashboard = {
  baseURL: 'https://onyx-harmony-239219.firebaseapp.com/api/dashboard',
} as AxiosRequestConfig;
